export enum EventCodeACE {
  OpenApplication = 'open-application',
  OfferAccepted = 'offer-accepted',
  OfferCancelledByAxo = 'offer-cancelled-by-axo',
  RegistrationCancelledByAxo = 'registration-cancelled-by-axo',
  OfferCancelledOnCustomerBehalf = 'offer-cancelled-on-customer-behalf',
  ChangedEmail = 'changed-email',
  ChangedPhone = 'changed-phone',
  // AddCoApplicant = 'add-co-applicant', // Not implemented yet.
  CloneApplication = 'clone-application',
  RemoveConsent = 'remove-consent',
  ConsentChanged = 'consent-changed',
  ArchiveApplication = 'archive-application',
  WithdrawnByCustomer = 'withdrawn-by-customer',
  MarkAsFraud = 'mark-as-fraud',
  UnmarkAsFraud = 'unmark-as-fraud',
  UpdateApplicationData = 'update-application-data',
  ProcessApplication = 'process-application',
}
